__turbopack_context__.v({
  "translateButton": "view-module__PIxKYW__translateButton",
  "translated": "view-module__PIxKYW__translated",
});
